<apx-chart
  [series]="chartData.series"
  [chart]="chartData.chart"
  [plotOptions]="chartData.plotOptions"
  [labels]="chartData.labels"
></apx-chart>
